//"use strict";

angular.module('cfn').factory('bookingRenderService', [
  'i18nFilter',
  'escapeHtmlFilter',
  'userSettingsService',
  function(i18nFilter, escapeHtmlFilter, userSettingsService) {
    // Private
    // Render Machine or Persons as Inner-Table (as CSS-Table because we don't want the hover and zebra-styles from cfnGrid)
    var resourceRenderer = function(rowIndex, column, value, rowValue, type) {
      var html = "<span class='innerTable'>";
      rowValue.resources
        .filter(function(item) {
          return item.type === type;
        })
        .forEach(function(item) {
          html +=
            "<span class='innerTR resource'>" +
            "   <span class='innerTD'>" +
            escapeHtmlFilter(item.name) +
            '</span>' +
            '</span>';
        });
      html += '</span>';
      return html;
    };

    var assetRenderer = function(rowIndex, column, value, rowValue) {
      var html = "<span class='innerTable'>";
      rowValue.assets.forEach(function(item) {
        html +=
          "<span class='innerTR resource'>" +
          "   <span class='innerTD'>" +
          escapeHtmlFilter(item.name) +
          '</span>' +
          '</span>';
      });
      html += '</span>';
      return html;
    };

    var personRenderer = function(rowIndex, column, value, rowValue) {
      return resourceRenderer(rowIndex, column, value, rowValue, 'Person');
    };

    var machineRenderer = function(rowIndex, column, value, rowValue) {
      return resourceRenderer(rowIndex, column, value, rowValue, 'Machine');
    };

    // Render Icon for Grid
    var activityIconRenderer = function(row, column, value) {
      if (!value) return undefined;
      var activities = value.split(',');
      var result = '<div style="float:right;clear:both;">';
      for (var i = 0; i < activities.length; i++) {
        var name = activities[i];
        var localizedName = i18nFilter('enums.BookingActivitiesEnum.' + name);
        localizedName = localizedName.replace(/\u00AD/g, ''); // removing soft-hyphen as workaround for Chrome-Bug in tooltip
        var icon = name;

        result += '<img style="opacity:0.8;height:18px;" ';
        result +=
          'src="img/icons/black/activities/' + icon.toLowerCase() + '.png" ';
        result += 'title="' + localizedName + '"/>';
      }
      result += '</div>';
      return result;
    };

    // Render Supplies & Products as Inner-Table (as CSS-Table because we don't want the hover and zebra-styles from cfnGrid)
    var supplyRenderer = function(rowIndex, column, value, rowValue) {
      var html = "<span class='innerTable'>";
      Array.prototype
        .concat(rowValue.supplys, rowValue.products)
        //.sort(function (a, b) { var result = a.name.localeCompare(b.name); })
        .forEach(function(item) {

          // CFNPOC-38876 ugly workaround because backend only supplies value and not enum option
          var unitTranslation = item.unit;

          if (unitTranslation === 'dt' && userSettingsService.getIsoCountryEnum() === 'FRA') {
            unitTranslation = 'qx';
          }

          html +=
            "<span class='innerTR supply'>" +
            "   <span class='innerTD'>" +
            item.amount +
            '</span>' +
            "   <span class='innerTD'>" +
            unitTranslation +
            '</span>' +
            "   <span class='innerTD'>" + escapeHtmlFilter(item.name) +
            '</span>' +
            '</span>';
        });
      html += '</span>';
      return html;
    };

    // Public
    return {
      activityIconRenderer: activityIconRenderer,
      assetRenderer: assetRenderer,
      supplyRenderer: supplyRenderer,
      personRenderer: personRenderer,
      machineRenderer: machineRenderer
    };
  }
]);
